<div class="container-item-nested">
  <ul class="sub-menu-list">
    <ng-content></ng-content>
  </ul>
</div>
